import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const dict = {
  en: {
    app_name: "Thqah",
    tagline: "AI-Powered Livestock Beauty Evaluation",
    tagline_sub: "Camels • Horses • Sheep • Goats • Falcons",
    // Nav
    home: "Home",
    dashboard: "Dashboard",
    leaderboard: "Leaderboard",
    competitions: "Competitions",
    experts: "Experts",
    subscribe: "Plans",
    login: "Sign In",
    register: "Sign Up",
    logout: "Sign Out",
    admin: "Admin",
    expert_panel: "Expert Panel",
    // Auth
    email: "Email",
    password: "Password",
    full_name: "Full Name",
    phone: "Phone",
    register_as: "Register as",
    role_user: "Owner",
    role_expert: "Expert (approval required)",
    dont_have_account: "Don't have an account?",
    already_have: "Already have an account?",
    sign_in_cta: "Sign in to your account",
    forgot_password: "Forgot password?",
    forgot_password_title: "Reset your password",
    forgot_password_intro: "Enter your email and we'll send you a secure link to reset your password.",
    send_reset_link: "Send reset link",
    reset_link_sent: "If the email exists, a reset link has been sent. Check your inbox and WhatsApp.",
    back_to_login: "Back to login",
    reset_password_title: "Set a new password",
    new_password: "New password",
    confirm_password: "Confirm new password",
    password_too_short: "Password must be at least 6 characters",
    passwords_dont_match: "Passwords do not match",
    save_new_password: "Save new password",
    password_updated_success: "Password updated successfully. Please sign in.",
    invalid_reset_link: "This reset link is invalid or has expired.",
    sign_up_cta: "Create your account",
    // Landing
    hero_title: "Know your livestock score in",
    hero_title_accent: "30 seconds 🔥",
    hero_sub: "AI vision + Gulf expert review. See your strengths, weaknesses & competition readiness — instantly.",
    get_started: "Start Evaluating Now",
    view_leaderboard: "Browse Top Livestock",
    try_free: "Try Free — No Sign-up",
    stat_users: "Owners",
    stat_animals: "Animals",
    stat_evaluations: "Evaluations",
    stat_experts: "Experts",
    how_title: "How it works",
    how_1_title: "Add your animal",
    how_1_desc: "Photos, breed, age, color — a few details in under a minute.",
    how_2_title: "Pick an evaluation",
    how_2_desc: "AI-only, Expert-only, or Full (AI + human expertise).",
    how_3_title: "Receive the report",
    how_3_desc: "Scored across beauty, symmetry, head, neck, back & legs — with tips.",
    categories_title: "Every breed. Every species.",
    cat_camel: "Camels",
    cat_horse: "Horses",
    cat_sheep: "Sheep",
    cat_goat: "Goats",
    cat_falcon: "Falcons",
    cat_other: "Other",
    // Dashboard
    my_animals: "My Animals",
    my_evaluations: "My Evaluations",
    add_animal: "Add Animal",
    no_animals: "You haven't added any animals yet.",
    no_evaluations: "No evaluations yet.",
    // Add Animal
    add_animal_title: "Add a new animal",
    step_details: "Details",
    step_media: "Photos & Video",
    step_review: "Review",
    animal_name: "Animal Name",
    animal_type: "Type",
    breed: "Breed",
    age_years: "Age (years)",
    gender: "Gender",
    male: "Male",
    female: "Female",
    color: "Color",
    owner_name: "Owner Name",
    location: "Location",
    description: "Description / Pedigree notes",
    upload_photos: "Upload photos (up to 3 recommended)",
    upload_videos: "Upload video (optional)",
    next: "Next",
    back: "Back",
    save: "Save",
    submit: "Submit",
    cancel: "Cancel",
    // Evaluation
    request_evaluation: "Request Evaluation",
    choose_mode: "Choose evaluation type",
    mode_ai: "AI Only",
    mode_ai_desc: "Fast, vision-based, detailed scoring.",
    mode_expert: "Expert Only",
    mode_expert_desc: "Reviewed by a certified Gulf judge.",
    mode_full: "Full (AI + Expert)",
    mode_full_desc: "Combined AI and human verdict — most authoritative.",
    start_evaluation: "Start Evaluation",
    evaluation_in_progress: "Evaluation in progress...",
    overall_score: "Overall Score",
    beauty: "Beauty",
    body_symmetry: "Body Symmetry",
    head: "Head",
    neck: "Neck",
    back_s: "Back",
    legs: "Legs",
    color_app: "Color & Appearance",
    strengths: "Strengths",
    weaknesses: "Areas for Improvement",
    recommendations: "Recommendations",
    share: "Share",
    certificate: "Certificate",
    certificate_no: "Certificate #",
    legal_note: "This evaluation is advisory and not an official judgment unless issued by a certified body.",
    // Competitions
    enter_competition: "Enter Competition",
    winners: "Top Entries",
    entry_fee: "Entry fee",
    // Plans
    plans_title: "Pick your plan",
    ios_paywall_note: "To subscribe, continue on our official website. Your subscription will activate on this device automatically after payment.",
    continue_on_website: "Continue on thaqh.com",
    ios_secure_note: "🔒 Secure payment via Tap — Mada, Visa, Mastercard, Apple Pay",
    free: "Free",
    basic: "Basic",
    gold: "Gold",
    pro: "Pro",
    vip: "VIP",
    per_month: "/mo",
    subscribe_now: "Subscribe",
    current_plan: "Current plan",
    benefit_compare_unlimited: "Unlimited 'Compare your livestock'",
    benefit_tamper_unlimited: "Unlimited tamper checks",
    // Admin
    admin_dashboard: "Admin Dashboard",
    users: "Users",
    pending_experts: "Pending Experts",
    approve: "Approve",
    reject: "Reject",
    revenue: "Revenue",
    // Expert
    expert_dashboard: "Expert Dashboard",
    pending_requests: "Pending Requests",
    completed: "Completed",
    earnings: "Earnings",
    claim: "Claim",
    assess: "Submit Assessment",
    expert_comment: "Comment",
    // misc
    status: "Status",
    pending: "Pending",
    ai_done: "AI Done",
    expert_pending: "Expert Pending",
    completed_s: "Completed",
    cancelled: "Cancelled",
    private: "Private",
    public: "Public",
    toggle_privacy: "Toggle Privacy",
    score: "Score",
    rank: "Rank",
    loading: "Loading...",
    save_success: "Saved",
    download_pdf: "Download",
    go_back: "Go back",
    search: "Search",
    all: "All",
    language: "العربية",
    // additions
    wallet: "Wallet",
    balance: "Balance",
    loyalty_points: "Loyalty Points",
    transactions: "Transactions",
    referral_program: "Referral Program",
    referral_help: "Share your code — you earn $5 + 50 points per signup.",
    referred_count: "Referred",
    copy: "Copy",
    notifications: "Notifications",
    no_notifications: "No notifications yet",
    mark_all_read: "Mark all read",
    sign_in_google: "Continue with Google",
    sign_in: "Sign In",
    or: "or",
    referral_code: "Referral code (optional)",
    have_code: "Have a discount code?",
    apply_code: "Apply",
    code_applied: "Code applied",
    print: "Print",
    score_breakdown: "Score Breakdown",
    official_evaluation: "Official Evaluation",
    create_competition: "Create Competition",
    title_field: "Title",
    description_field: "Description",
    start_date: "Start date",
    end_date: "End date",
    discount_codes: "Discount Codes",
    create_code: "Create Code",
    percent_off: "Percent off",
    max_uses: "Max uses",
    vote: "Vote",
    voted: "Voted",
    // Phase 3 — Expert levels
    sar: "SAR",
    become_expert: "Become an Expert",
    expert_level: "Expert Level",
    choose_level: "Choose your level",
    level_beginner: "Beginner",
    level_pro: "Pro",
    level_vip: "VIP Verified",
    level_beginner_desc: "Limited experience · Fast approval · 30% commission · 5 evals/day",
    level_pro_desc: "Intermediate · Certifications required · 25% commission · 15 evals/day",
    level_vip_desc: "Top-tier · Certs + ID + bank · 20% commission · Priority & fast-track",
    upload_certs: "Upload certifications",
    upload_id: "Upload ID",
    bank_account: "Bank account / IBAN",
    sort_best: "Best",
    sort_cheapest: "Cheapest",
    sort_fastest: "Fastest",
    sort_vip: "VIP only",
    expert_rating: "Expert rating",
    rate_your_expert: "Rate this expert",
    boost_profile: "Boost profile 7 days",
    boosted_badge: "✨ Boosted",
    change_level: "Change level",
    daily_quota: "Daily quota",
    pending_review: "Pending review",
    ratings_count: "ratings",
    send_rating: "Submit rating",
    already_rated: "Already rated",
    promote_to_vip: "Promote to VIP",
    demote_to_pro: "Demote to Pro",
    demote_to_beginner: "Demote to Beginner",
    apply_expert: "Apply as Expert",
    specialty: "Specialty",
    cert_reqs_beginner: "optional",
    cert_reqs_pro: "required (certs)",
    cert_reqs_vip: "required (certs + ID + bank)",
    winner_of_the_week: "Winner of the Week",
    winner_quote: "A new champion on Thqah. Beauty deserves recognition — and rankings deserve to be earned.",
    view_certificate: "View Certificate",
    rank_like_me: "Rank like me — start your evaluation",
    demo_data: "Demo Data",
    demo_present: "Demo data active (8 animals + 5 experts)",
    demo_absent: "Demo data cleared. You can re-seed it anytime.",
    clear_demo: "Clear Demo Data",
    clear_demo_confirm: "This permanently deletes all demo accounts, animals, evaluations and competitions. Continue?",
    reseed_demo: "Re-seed Demo",
    welcome_bonus: "Welcome Bonus",
    credits_left: "You have {n} free AI evaluations remaining",
    credits_used_up: "You've used your free evaluations",
    upgrade_helper: "Upgrade for unlimited evaluations + expert discounts",
    upgrade_now: "Upgrade Now",
    upgrade: "Upgrade",
    catalog: "Standards Guide",
    catalog_kicker: "Mazayen Guide",
    catalog_title: "Gulf Mazayen Beauty Standards Catalog",
    catalog_intro: "Learn the most prized traits for each animal you own. Males come first (they showcase the breed's apex characteristics), then top breeds, available colors, and the official beauty criteria. Use this guide while filling in your animal's profile to get the strongest evaluation.",
    male_showcase: "Male Showcase",
    female_form: "Female",
    breeds: "Breeds",
    colors_label: "Colors",
    ideal_traits: "Ideal Traits",
    evaluate_this: "Evaluate This Animal",
    filter_all: "All Animals",
    // Wallet top-up
    topup_wallet: "Top up Wallet",
    topup_helper: "Add credit to your wallet — bigger packs include a bonus.",
    topup_50: "50 SAR",
    topup_100: "100 SAR · +5 bonus",
    topup_250: "250 SAR · +20 bonus",
    topup_500: "500 SAR · +60 bonus",
    redirecting: "Redirecting to checkout…",
    // Share
    share_whatsapp: "WhatsApp",
    share_x: "X / Twitter",
    share_telegram: "Telegram",
    share_instagram: "Instagram",
    share_tiktok: "TikTok",
    share_instagram_hint: "Image saved — paste in Instagram",
    share_tiktok_hint: "Image saved — share on TikTok",
    copy_link: "Copy Link",
    share_more: "More",
    share_msg: "Look at my Thqah evaluation certificate ·",
    // Expert showcase / trust
    best_experts_today: "Best Experts Today",
    expert_leaderboard: "Expert Leaderboard",
    leaderboard_day: "Today",
    leaderboard_week: "This Week",
    leaderboard_month: "This Month",
    leaderboard_all: "All Time",
    achievements: "Achievements",
    gallery: "Gallery",
    services: "Services Offered",
    response_time: "Avg Response",
    satisfaction: "Satisfaction",
    completed_evals: "Completed",
    minutes_short: "min",
    book_service: "Book Now",
    trust_verified: "Verified Expert",
    trust_top_rated: "Top Rated",
    trust_fast: "Fast Response",
    trust_vip: "VIP Verified",
    no_achievements: "No achievements added yet",
    no_gallery: "No photos added yet",
    edit_profile: "Edit Profile",
    save_profile: "Save Profile",
    profile_saved: "Profile saved",
    add_achievement: "Add Achievement",
    add_to_gallery: "Add Photo",
    achievement_title: "Title (e.g., Winner — Mazayen Cup)",
    achievement_year: "Year",
    upload_photo: "Upload Photo",
    bio: "Bio",
    expert_count_today: "evaluations today",
    rank: "Rank",
    rating: "Rating",
    reviews: "Reviews",
    pick_expert: "Choose Expert",
    hide: "Hide",
    show: "Show",
    hidden: "Hidden",
    visibility: "Visibility",
    // Free try & tiers
    free_try_title: "Free 30-second AI Score",
    free_try_sub: "Drop a photo of your animal — no sign-up required. Get a tier badge instantly.",
    free_try_cta: "Try Now — Free",
    drop_photo_hint: "Drop a photo here, or tap to browse",
    analyzing: "Scanning your animal…",
    your_score: "Your Score",
    locked_full_report: "Unlock the full report",
    locked_helper: "Detailed scores per body part, expert tips, shareable certificate, ranking & more.",
    create_free_account: "Create a free account",
    full_results_after_signup: "Full results unlocked after sign-up",
    tier_elite: "Elite",
    tier_premium: "Premium",
    tier_strong: "Strong",
    tier_good: "Good",
    tier_developing: "Developing",
    tier_beginner: "Beginner",
    elite_msg: "🔥 Your livestock is among the elite",
    mazayen_readiness: "Mazayen Competition Readiness",
    mazayen_ready_high: "Highly competitive — submit to a contest now",
    mazayen_ready_mid: "Solid — refine the weak spots and you'll compete",
    mazayen_ready_low: "Foundation needs work before competing",
    // Period tabs (animals leaderboard)
    top_today: "Top Today",
    top_week: "Top This Week",
    top_month: "Top This Month",
    top_all: "All Time",
    challenge_today: "Today's Challenge",
    challenge_subtitle: "{n} animals submitted today — compete for #1",
    challenge_no_subs: "No submissions yet today — be first to enter!",
    yesterday_winner: "Yesterday's Winner",
    submit_animal: "Submit Animal",
    join_challenge: "Join the Challenge",
    top1_badge: "Top 1",
    top10_badge: "Top 10",
    top100_badge: "Top 100",
    regional_reach: "Regional Reach",
    regional_subtitle: "Trusted by livestock owners and judges across the GCC",
    country_users: "Owners",
    country_experts: "Experts",
    country_animals: "Animals",
    // Pricing benefits
    pricing_title: "Plans built for serious owners",
    pricing_sub: "Pick the plan that wins your competition.",
    most_popular: "Most Popular",
    first_eval_free: "First evaluation free 🎁",
    benefit_30s: "30-second AI score with tier badge",
    benefit_report: "Strengths, weaknesses & competition-readiness report",
    benefit_share: "Shareable certificate (WhatsApp / X / Instagram)",
    benefit_expert: "Expert review by Gulf judges",
    benefit_unlimited: "Unlimited evaluations",
    benefit_priority: "Priority expert queue",
    benefit_videocall: "Video consultations",
    benefit_history: "Full evaluation history",
    benefit_compete: "Enter contests & leaderboards",
    benefit_certificate: "Verifiable certificates with QR",
    // Social proof
    social_evaluations: "{n}+ animals evaluated",
    social_users: "{n}+ active owners",
    social_experts: "{n}+ verified experts",
    // Footer trust
    privacy_policy: "Privacy Policy",
    terms_of_service: "Terms of Service",
    contact_support: "Contact Support",
    whatsapp_support: "WhatsApp Support",
    official_email: "Official Email",
    privacy_title: "Privacy Policy",
    terms_title: "Terms of Service",
    last_updated: "Last updated",
    // Smart breed + pricing (Phase 15)
    breed_detected: "AI Breed Detection",
    breed_label: "Detected Breed",
    confidence_label: "Confidence",
    your_choice: "Your Choice",
    breed_match: "Match",
    breed_mismatch: "Mismatch — verify breed",
    classification_label: "Classification",
    cls_ordinary: "Ordinary",
    cls_good: "Good",
    cls_premium: "Premium",
    cls_elite: "Elite",
    estimated_price: "Estimated Market Value",
    price_range: "Range",
    price_disclaimer: "Indicative range based on AI score + breed; not a binding offer.",
    score_out_of_10: "Score",
    // Market (Phase 16)
    market: "Market",
    market_title: "Thqah Market",
    market_subtitle: "Verified livestock with AI-graded valuations — listed by owners across the Gulf",
    sale_price: "Asking Price",
    estimated_value: "AI Estimate",
    contact_whatsapp: "Contact via WhatsApp",
    list_for_sale: "List for Sale",
    unlist: "Remove Listing",
    listed_for_sale: "Listed for Sale",
    asking_price_label: "Asking Price (SAR)",
    whatsapp_label: "WhatsApp Number (digits only, with country code)",
    whatsapp_placeholder: "966501234567",
    no_market_results: "No animals match your filters",
    sort_newest: "Newest",
    sort_price_asc: "Lowest Price",
    sort_price_desc: "Highest Price",
    sort_score: "Highest Score",
    save_listing: "Save Listing",
    listing_saved: "Listing updated",
    market_disclaimer: "Thqah connects buyers and sellers; all transactions are between the parties.",
    // Referral
    referral_invite: "Invite a friend, both get a free evaluation",
    referral_invite_sub: "Share your code below — when your friend signs up, you both get a free AI evaluation.",
    share_referral: "Share My Code",
    // Share result
    share_result: "Share Result",
    share_result_msg: "I just scored",
    share_image: "Save Share Image",

    // Mobile home dashboard
    mhd_welcome: "Welcome to",
    mhd_platform: "Thqah Mazayen Platform",
    mhd_subtitle: "Professional livestock evaluation experience",
    mhd_search_placeholder: "Search animals, owners, mazayen…",
    mhd_total_users: "Total users",
    mhd_total_animals: "Total animals",
    mhd_active_evals: "Active evaluations",
    mhd_active_aucts: "Active experts",
    mhd_services_title: "Main Services",
    mhd_hero_title: "Discover the Elite",
    mhd_hero_sub: "Top breeds and the strongest competitions",
    mhd_hero_cta: "Explore Now",
    mhd_recent_title: "Recent Activity",
    mhd_act_eval_done: "New evaluation completed",
    mhd_act_market_listed: "New listing in the market",
    mhd_act_expert_review: "New expert review",
    svc_register: "Register Animal",
    svc_evaluate: "Evaluate",
    svc_tamper: "Tamper Check",
    svc_auctions: "Thqah Market",
    svc_experts: "Experts",
    svc_contests: "Competitions",
    svc_vet: "Vet Clinic",
    svc_subscribe: "Subscribe",
    svc_subscribe_badge: "99/mo",
    svc_grow: "Grow Your Livestock",
    svc_grow_badge: "New",
    svc_influencers: "Influencers",
    svc_document: "Document Livestock",
    svc_specs: "Beauty Standards",
    svc_track: "Mode",
    svc_sell: "Sell with Thqah",
    nav_sell: "Sell with Thqah",
    // Track toggle (Mazayen vs Races)
    track_mazayen: "Mazayen",
    track_races: "Races",
    mhd_races_title: "Camel Racing services",
    // Racing tiles
    svc_race_register: "Register Racer",
    svc_race_eval: "Race Readiness",
    svc_race_sell: "Sell Racing Camel",
    svc_race_calendar: "Race Calendar",
    svc_pedigree: "Pedigree Cert",
    // Race Calendar page
    races_title: "Camel Racing Calendar",
    races_sub: "Live directory of major camel races across the Gulf — dates, prizes, and entry windows.",
    races_no_events: "No upcoming races yet — we're updating the calendar.",
    races_view_details: "Details",
    races_register_cta: "Register your camel",
    races_prize: "Prize Pool",
    races_entry_fee: "Entry Fee",
    races_until: "until",
    races_open: "Registration Open",
    races_closed: "Registration Closed",
    races_filter_all: "All",
    races_filter_sa: "Saudi",
    races_filter_ae: "UAE",
    races_filter_kw: "Kuwait",
    races_filter_qa: "Qatar",
    // Race Readiness page
    re_title: "Race Readiness Analysis",
    re_sub: "Upload a clear photo + (optional) a short video. AI evaluates fitness, gait, and racing potential.",
    re_upload: "Upload photo",
    re_video: "Upload short video (optional)",
    re_run: "Run analysis",
    re_running: "Analyzing race readiness…",
    re_score: "Race readiness",
    re_breakdown: "Detailed breakdown",
    re_fitness: "Fitness",
    re_build: "Build & frame",
    re_legs_back: "Legs & back",
    re_neck_head: "Neck & head",
    re_recommendations: "Coach recommendations",
    re_pro_cta: "Get a Pro Report (199 SAR)",
    re_pro_includes: "Includes 5-generation pedigree comparison, expert-reviewed training plan, and certified PDF.",
    // Pedigree page
    ped_title: "Racing Pedigree Certificates",
    ped_sub: "Document up to 5 generations with breed verification + race-history record. Increases the resale value of your racing camel by 100k+ SAR.",
    ped_apply: "Apply for certificate",
    ped_price: "299 SAR per certificate",
    ped_includes: "Includes:",
    ped_inc1: "5-generation lineage chart with photos",
    ped_inc2: "Race history of sire & dam",
    ped_inc3: "QR-verified printable certificate",
    ped_inc4: "Listing eligibility on Thqah Marketplace",
    ped_inc5: "Annual renewal + transfer support",
    ped_form_camel: "Camel name",
    ped_form_microchip: "Microchip / ID",
    ped_form_sire: "Sire's name & owner contact",
    ped_form_dam: "Dam's name & owner contact",
    ped_form_history: "Race history (results, dates)",
    ped_submit: "Submit application — 299 SAR",
    ped_submitted: "Application submitted! We'll review and respond within 48 hours.",
    ped_pdf_soon: "PDF certificate emailed within 5 business days of approval.",
    ped_form_lineage: "Notable bloodlines (optional)",
    // Sell-through-Thqah landing
    sell_eyebrow: "Brokerage Service",
    sell_title: "Sell your livestock through Thqah only",
    sell_sub_1: "We never list any animal without an evaluation.",
    sell_sub_2: "We receive your details, evaluate accurately, set the right price, and present it to elite buyers.",
    sell_b1_t: "Reach top dealers",
    sell_b1_d: "Curated network of verified high-spend buyers across the Gulf.",
    sell_b2_t: "Professional pricing",
    sell_b2_d: "Expert + AI valuation pinpoints the right asking price — no underselling.",
    sell_b3_t: "Premium showcase",
    sell_b3_d: "Featured placement, polished media, and full provenance.",
    sell_how_title: "How it works",
    sell_step1_t: "Submit your animal's details",
    sell_step1_d: "Photos, video, breed, history. A few minutes via the app.",
    sell_step2_t: "We evaluate & price",
    sell_step2_d: "Expert review + AI scoring. You receive a recommended ask.",
    sell_step3_t: "We present to elite buyers",
    sell_step3_d: "Featured listing, direct buyer offers, secure payout.",
    sell_plan_badge: "GOLD MEMBERSHIP",
    sell_pricing_desc: "Subscription unlocks evaluation, pricing, and premium placement. Commission applies only on a successful sale.",
    sell_commission_line: "5% commission on sale only",
    sell_inc1: "Unlimited expert + AI evaluations",
    sell_inc2: "Premium showcase to vetted buyers",
    sell_inc3: "Tamper check + private listings",
    sell_inc4: "Cancel anytime",
    sell_cta: "Subscribe & list now",
    sell_secure_payment: "Secure payment via Tap (mada • Apple Pay • Visa)",
    sell_finepoint_t: "Important",
    sell_finepoint_d: "Animals must pass evaluation before being listed publicly. The 5% commission is deducted automatically from the seller's payout — only when the sale closes.",
    sell_browse_link: "Browse the catalog of evaluated livestock",
    // Request expert evaluation
    req_cta: "Request Private Expert Evaluation",
    req_cta_sub: "Upload photos + videos and get an expert opinion directly.",
    req_cta_login: "Login to Request Evaluation",
    req_title: "Private Expert Evaluation",
    req_title_small: "New request",
    req_service: "Service Type",
    req_photos: "Photos",
    req_videos: "Videos",
    req_notes: "Notes for the expert",
    req_notes_placeholder: "Breed, age, any specific concern you want the expert to focus on…",
    req_total: "Total fee",
    req_submit: "Send to Expert",
    req_sent: "Sent ✓ Expert will respond shortly.",
    req_failed: "Submission failed — please retry.",
    req_need_media: "Please upload at least one photo or video.",
    req_too_large_img: "Image exceeds 10MB limit.",
    req_too_large_vid: "Video exceeds 50MB limit.",
    req_upload_failed: "Upload failed — please retry.",
    req_login_first: "Please login first.",
    req_disclaimer: "The expert will review your media and respond via the app. You can track the status in your dashboard.",
    animal_name_optional: "Animal name (optional)",
    breed_optional: "Breed (optional)",
    upload: "Upload",
    sending: "Sending…",
    bn_home: "Home",
    bn_alerts: "Alerts",
    bn_add: "Add",
    bn_messages: "Wallet",
    bn_more: "More",
    sign_in_whatsapp: "Continue with WhatsApp",
    sign_in_otp: "Continue with SMS OTP",
    sign_in_apple: "Continue with Apple",
    coming_soon: "Soon",
    // Compare feature
    cmp_title: "Compare Your Livestock",
    cmp_subtitle: "Upload your animal's photo and a top-grade reference. AI highlights the gap in 5 seconds.",
    cmp_tagline: "Side-by-side AI comparison",
    cmp_yours: "Your Animal",
    cmp_yours_short: "Yours",
    cmp_yours_hint: "Clear side or front-profile photo, good light.",
    cmp_reference: "Reference (Excellent)",
    cmp_ref_short: "Ref.",
    cmp_reference_hint: "A top-tier animal from any breed you admire.",
    cmp_too_large: "Image must be under 8MB.",
    cmp_need_both: "Please upload both images.",
    cmp_error: "Analysis failed. Please try again.",
    cmp_start: "Start Comparison",
    cmp_analyzing: "Analyzing…",
    cmp_step1: "Upload both images",
    cmp_step2: "AI analysis",
    cmp_step3: "Clear verdict",
    cmp_advisory: "Initial result from AI — final judgment belongs to a certified expert.",
    cmp_free_quota: "Free plan: 1 comparison per day. Subscribe for unlimited.",
    cmp_subscribe: "Subscribe",
    cmp_verdict: "Verdict",
    cmp_breakdown: "Dimension Breakdown",
    cmp_cta_expert: "Get Expert Evaluation",
    cmp_cta_pdf: "Download PDF",
    cmp_cta_retry: "Compare Again",
    svc_compare: "Compare",
    mhd_cta_compare: "Compare your animal",
    // Tamper Check feature
    tc_title: "Tamper Check",
    tc_subtitle: "Upload a photo — we detect editing or AI-generated signals using EXIF metadata + vision AI.",
    tc_upload_hint: "Clear full image of the animal. Max 10MB.",
    tc_start: "Analyze Image",
    tc_analyzing: "Analyzing photo…",
    tc_score: "Authenticity score",
    tc_flags: "Detected signals",
    tc_exif_title: "EXIF metadata",
    tc_no_flags: "No tamper signals detected. Image appears authentic.",
    tc_advisory: "Advisory only — expert review still recommended for competitions.",
    tc_free_quota: "Free plan: 2 checks per day. Subscribe for unlimited.",
    tc_retry: "Check another",
    tc_bad_file: "Upload an image first.",
    tc_too_large: "Image must be under 10MB.",
    tc_error: "Analysis failed. Please try again.",
    // Vet Clinic feature
    vet_list_title: "Vet Clinic",
    vet_list_sub: "Licensed vets respond to your case through the app — photo, symptoms & a prescription.",
    vet_apply_cta: "Apply as a Vet",
    vet_empty: "No approved vets yet. Check back soon.",
    vet_profile_book: "Request Consultation",
    vet_profile_services: "Services",
    vet_profile_about: "About",
    vet_request_title: "Request Vet Consultation",
    vet_service: "Consultation type",
    vet_symptoms: "Symptoms / Reason",
    vet_symptoms_ph: "Describe the issue, duration, and any prior treatment…",
    vet_urgency: "Urgency",
    vet_urgency_low: "Low",
    vet_urgency_normal: "Normal",
    vet_urgency_high: "High",
    vet_submit: "Send to vet",
    vet_sent: "Request sent — vet will respond shortly.",
    vet_my_cons: "My Consultations",
    vet_status_pending: "Awaiting vet reply",
    vet_status_answered: "Answered",
    vet_status_closed: "Closed",
    vet_response: "Vet's response",
    vet_prescription: "Prescription",
    vet_rate: "Rate consultation",
    vet_already_rated: "Rated ✓",
    vet_dashboard: "Vet Dashboard",
    vet_pending: "Pending requests",
    vet_answered: "Answered",
    vet_respond_cta: "Respond",
    vet_respond_text: "Diagnosis & advice",
    vet_respond_rx: "Prescription (optional)",
    vet_send_response: "Send response",
    vet_apply_title: "Apply as a licensed Vet",
    vet_apply_sub: "Fill the details below. Admin reviews applications within 24h.",
    vet_clinic_name: "Clinic name",
    vet_license_id: "License ID",
    vet_specialty: "Specialty",
    vet_years_exp: "Years of experience",
    vet_fee_sar: "Base consultation fee (SAR)",
    vet_bio: "Bio (English)",
    vet_bio_ar: "Bio (Arabic)",
    vet_apply_submit: "Submit application",
    vet_applied_ok: "Application submitted — we'll notify you after review.",
    vet_pending_status: "Your vet application is under review.",
    vet_rejected_status: "Your vet application was not approved.",
  },
  ar: {
    app_name: "ثقة",
    tagline: "تقييم مزاين المواشي بالذكاء الاصطناعي",
    tagline_sub: "إبل • خيول • أغنام • ماعز • صقور",
    home: "الرئيسية",
    dashboard: "لوحتي",
    leaderboard: "الترتيب",
    competitions: "المسابقات",
    experts: "الخبراء",
    subscribe: "الاشتراكات",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    logout: "خروج",
    admin: "الإدارة",
    expert_panel: "لوحة الخبير",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    full_name: "الاسم الكامل",
    phone: "رقم الجوال",
    register_as: "التسجيل كـ",
    role_user: "مالك",
    role_expert: "خبير (يتطلب موافقة)",
    dont_have_account: "ليس لديك حساب؟",
    already_have: "لديك حساب بالفعل؟",
    sign_in_cta: "ادخل إلى حسابك",
    sign_up_cta: "أنشئ حسابك",
    forgot_password: "نسيت كلمة المرور؟",
    forgot_password_title: "إعادة تعيين كلمة المرور",
    forgot_password_intro: "أدخل بريدك الإلكتروني وسنرسل لك رابطاً آمناً لإعادة تعيين كلمة المرور.",
    send_reset_link: "إرسال رابط إعادة التعيين",
    reset_link_sent: "إذا كان البريد مسجلاً، تم إرسال رابط إعادة التعيين. تحقق من بريدك أو الواتساب.",
    back_to_login: "العودة لتسجيل الدخول",
    reset_password_title: "تعيين كلمة مرور جديدة",
    new_password: "كلمة المرور الجديدة",
    confirm_password: "تأكيد كلمة المرور",
    password_too_short: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
    passwords_dont_match: "كلمتا المرور غير متطابقتين",
    save_new_password: "حفظ كلمة المرور الجديدة",
    password_updated_success: "تم تحديث كلمة المرور بنجاح. الرجاء تسجيل الدخول.",
    invalid_reset_link: "رابط إعادة التعيين غير صالح أو منتهي الصلاحية.",
    hero_title: "اعرف تقييم حلالك خلال",
    hero_title_accent: "٣٠ ثانية 🔥",
    hero_sub: "تحليل ذكي + تقييم خبراء — واعرف قوتك في المزاين فوراً.",
    get_started: "ابدأ التقييم الآن",
    view_leaderboard: "تصفّح أفضل الحلال",
    try_free: "جرّب مجاناً — بدون تسجيل",
    stat_users: "المالكون",
    stat_animals: "الحيوانات",
    stat_evaluations: "التقييمات",
    stat_experts: "الخبراء",
    how_title: "كيف يعمل؟",
    how_1_title: "أضف حيوانك",
    how_1_desc: "الصور، السلالة، العمر، اللون — بيانات سريعة في دقيقة.",
    how_2_title: "اختر نوع التقييم",
    how_2_desc: "ذكاء اصطناعي فقط، أو خبير فقط، أو تقييم كامل.",
    how_3_title: "استلم التقرير",
    how_3_desc: "درجات الجمال والتناسق والرأس والرقبة والظهر والأرجل مع التوصيات.",
    categories_title: "كل السلالات. كل الأنواع.",
    cat_camel: "إبل",
    cat_horse: "خيول",
    cat_sheep: "أغنام",
    cat_goat: "ماعز",
    cat_falcon: "صقور",
    cat_other: "أخرى",
    my_animals: "حيواناتي",
    my_evaluations: "تقييماتي",
    add_animal: "إضافة حيوان",
    no_animals: "لم تضف أي حيوان بعد.",
    no_evaluations: "لا توجد تقييمات.",
    add_animal_title: "إضافة حيوان جديد",
    step_details: "البيانات",
    step_media: "الصور والفيديو",
    step_review: "المراجعة",
    animal_name: "اسم الحيوان",
    animal_type: "النوع",
    breed: "السلالة",
    age_years: "العمر (سنوات)",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    color: "اللون",
    owner_name: "اسم المالك",
    location: "الموقع",
    description: "الوصف / ملاحظات النسب",
    upload_photos: "ارفع الصور (ثلاث صور مفضلة)",
    upload_videos: "ارفع فيديو (اختياري)",
    next: "التالي",
    back: "السابق",
    save: "حفظ",
    submit: "إرسال",
    cancel: "إلغاء",
    request_evaluation: "طلب تقييم",
    choose_mode: "اختر نوع التقييم",
    mode_ai: "ذكاء اصطناعي فقط",
    mode_ai_desc: "تقييم سريع عبر الرؤية الحاسوبية مع تفاصيل دقيقة.",
    mode_expert: "خبير فقط",
    mode_expert_desc: "مراجعة من محكّم خليجي معتمد.",
    mode_full: "تقييم كامل (ذكاء + خبير)",
    mode_full_desc: "الأدق والأكثر موثوقية.",
    start_evaluation: "ابدأ التقييم",
    evaluation_in_progress: "التقييم قيد المعالجة...",
    overall_score: "الدرجة الكلية",
    beauty: "الجمال",
    body_symmetry: "تناسق الجسم",
    head: "الرأس",
    neck: "الرقبة",
    back_s: "الظهر",
    legs: "الأرجل",
    color_app: "اللون والمظهر",
    strengths: "نقاط القوة",
    weaknesses: "نقاط للتحسين",
    recommendations: "التوصيات",
    share: "مشاركة",
    certificate: "الشهادة",
    certificate_no: "شهادة #",
    legal_note: "هذا التقييم استرشادي وليس حكمًا رسميًا إلا إذا صدر من جهة معتمدة.",
    enter_competition: "دخول المسابقة",
    winners: "أعلى المشاركات",
    entry_fee: "رسوم الدخول",
    plans_title: "اختر خطتك",
    ios_paywall_note: "للاشتراك، تابع عبر موقعنا الرسمي. الاشتراك سيُفعَّل تلقائياً على هذا الجهاز فور إتمام الدفع.",
    continue_on_website: "متابعة عبر thaqh.com",
    ios_secure_note: "🔒 دفع آمن عبر Tap — مدى، Visa، Mastercard، Apple Pay",
    free: "مجاني",
    basic: "أساسي",
    gold: "ذهبية",
    pro: "احترافي",
    vip: "كبار الشخصيات",
    per_month: "/شهرياً",
    subscribe_now: "اشترك الآن",
    current_plan: "خطتك الحالية",
    benefit_compare_unlimited: "مقارنة حلالك بلا حدود",
    benefit_tamper_unlimited: "كشف العبث بلا حدود",
    admin_dashboard: "لوحة الإدارة",
    users: "المستخدمون",
    pending_experts: "خبراء قيد الاعتماد",
    approve: "اعتماد",
    reject: "رفض",
    revenue: "الإيرادات",
    expert_dashboard: "لوحة الخبير",
    pending_requests: "طلبات جديدة",
    completed: "المكتملة",
    earnings: "الأرباح",
    claim: "استلام",
    assess: "إرسال التقييم",
    expert_comment: "تعليق",
    status: "الحالة",
    pending: "قيد الانتظار",
    ai_done: "تم الذكاء",
    expert_pending: "بانتظار الخبير",
    completed_s: "مكتمل",
    cancelled: "ملغي",
    private: "خاص",
    public: "عام",
    toggle_privacy: "تغيير الخصوصية",
    score: "الدرجة",
    rank: "الترتيب",
    loading: "جارٍ التحميل...",
    save_success: "تم الحفظ",
    download_pdf: "تحميل",
    go_back: "رجوع",
    search: "بحث",
    all: "الكل",
    language: "English",
    // additions
    wallet: "المحفظة",
    balance: "الرصيد",
    loyalty_points: "نقاط الولاء",
    transactions: "العمليات",
    referral_program: "برنامج الإحالة",
    referral_help: "شارك كودك — تحصل على 5$ + 50 نقطة لكل تسجيل جديد.",
    referred_count: "الإحالات",
    copy: "نسخ",
    notifications: "الإشعارات",
    no_notifications: "لا توجد إشعارات",
    mark_all_read: "تحديد الكل كمقروء",
    sign_in_google: "متابعة عبر جوجل",
    sign_in: "دخول",
    or: "أو",
    referral_code: "كود إحالة (اختياري)",
    have_code: "لديك كود خصم؟",
    apply_code: "تطبيق",
    code_applied: "تم تطبيق الكود",
    print: "طباعة",
    score_breakdown: "تفصيل الدرجات",
    official_evaluation: "تقييم رسمي",
    create_competition: "إنشاء مسابقة",
    title_field: "العنوان",
    description_field: "الوصف",
    start_date: "تاريخ البداية",
    end_date: "تاريخ النهاية",
    discount_codes: "أكواد الخصم",
    create_code: "إنشاء كود",
    percent_off: "نسبة الخصم %",
    max_uses: "الحد الأقصى للاستخدام",
    vote: "صوّت",
    voted: "صوّتت",
    // Phase 3 — Expert levels
    sar: "ريال",
    become_expert: "سجّل كخبير",
    expert_level: "مستوى الخبير",
    choose_level: "اختر مستواك",
    level_beginner: "مبتدئ",
    level_pro: "محترف",
    level_vip: "VIP موثّق",
    level_beginner_desc: "خبرة محدودة · موافقة سريعة · عمولة 30% · 5 تقييمات/يوم",
    level_pro_desc: "خبرة متوسطة · شهادات · عمولة 25% · 15 تقييم/يوم",
    level_vip_desc: "VIP معتمد · شهادات كاملة + هوية · عمولة 20% · أولوية وتقييمات سريعة",
    upload_certs: "رفع الشهادات",
    upload_id: "رفع الهوية",
    bank_account: "الحساب البنكي / IBAN",
    sort_best: "الأفضل",
    sort_cheapest: "الأرخص",
    sort_fastest: "الأسرع",
    sort_vip: "VIP فقط",
    expert_rating: "تقييم الخبير",
    rate_your_expert: "قيّم الخبير",
    boost_profile: "إبراز الملف 7 أيام",
    boosted_badge: "✨ مميّز",
    change_level: "تغيير المستوى",
    daily_quota: "الحصة اليومية",
    pending_review: "بانتظار المراجعة",
    ratings_count: "تقييم",
    send_rating: "إرسال التقييم",
    already_rated: "تم التقييم",
    promote_to_vip: "ترقية إلى VIP",
    demote_to_pro: "إعادة إلى Pro",
    demote_to_beginner: "إعادة إلى مبتدئ",
    apply_expert: "تقديم طلب خبير",
    specialty: "التخصص",
    cert_reqs_beginner: "اختياري",
    cert_reqs_pro: "مطلوب (شهادات)",
    cert_reqs_vip: "مطلوب (شهادات + هوية + حساب بنكي)",
    winner_of_the_week: "بطل الأسبوع",
    winner_quote: "تتويج جديد على منصة ثقة. الجمال يستحق التوثيق، والترتيب يستحق المنافسة.",
    view_certificate: "عرض الشهادة",
    rank_like_me: "تبيها مثله؟ ابدأ تقييمك",
    demo_data: "البيانات التجريبية",
    demo_present: "البيانات التجريبية نشطة (8 حيوانات + 5 خبراء)",
    demo_absent: "البيانات التجريبية محذوفة. يمكن إعادة إدراجها.",
    clear_demo: "مسح البيانات التجريبية",
    clear_demo_confirm: "سيتم حذف كل الحسابات والحيوانات والمسابقات التجريبية نهائياً. متابعة؟",
    reseed_demo: "إعادة إدراج البيانات",
    welcome_bonus: "هدية الترحيب",
    credits_left: "لديك {n} تقييمات AI مجانية متبقية",
    credits_used_up: "انتهت تقييماتك المجانية",
    upgrade_helper: "اشترك لتحصل على تقييمات غير محدودة + خصومات على الخبراء",
    upgrade_now: "ترقية الآن",
    upgrade: "ترقية",
    catalog: "دليل المعايير",
    catalog_kicker: "دليل المزاين",
    catalog_title: "كتالوج معايير المزاين الخليجية",
    catalog_intro: "تعرّف على أجمل المواصفات لكل نوع من حيواناتك. الذكر أولاً (لأنه يُظهر الصفات الأبرز للسلالة)، السلالات الأكثر قيمة، الألوان المتاحة، ومعايير الجمال المعتمدة. استخدم هذا الدليل وأنت تعبّئ بيانات حيوانك للحصول على أفضل تقييم.",
    male_showcase: "عرض الفحل",
    female_form: "الأنثى",
    breeds: "السلالات",
    colors_label: "الألوان",
    ideal_traits: "أجمل المواصفات",
    evaluate_this: "قيِّم هذا الحيوان الآن",
    filter_all: "كل الحيوانات",
    // Wallet top-up
    topup_wallet: "شحن المحفظة",
    topup_helper: "أضف رصيداً إلى محفظتك — الباقات الأكبر تحصل على هدية إضافية.",
    topup_50: "50 ريال",
    topup_100: "100 ريال · +5 هدية",
    topup_250: "250 ريال · +20 هدية",
    topup_500: "500 ريال · +60 هدية",
    redirecting: "جاري التحويل لإتمام الدفع…",
    // Share
    share_whatsapp: "واتساب",
    share_x: "إكس / تويتر",
    share_telegram: "تيليجرام",
    share_instagram: "إنستغرام",
    share_tiktok: "تيك توك",
    share_instagram_hint: "تم حفظ الصورة — الصقها في إنستغرام",
    share_tiktok_hint: "تم حفظ الصورة — شاركها على تيك توك",
    copy_link: "نسخ الرابط",
    share_more: "المزيد",
    share_msg: "شاهد شهادة تقييمي على ثقة ·",
    // Expert showcase / trust
    best_experts_today: "أفضل الخبراء اليوم",
    expert_leaderboard: "ترتيب الخبراء",
    leaderboard_day: "اليوم",
    leaderboard_week: "هذا الأسبوع",
    leaderboard_month: "هذا الشهر",
    leaderboard_all: "كل الوقت",
    achievements: "الإنجازات",
    gallery: "المعرض",
    services: "الخدمات المقدّمة",
    response_time: "متوسط الرد",
    satisfaction: "نسبة الرضا",
    completed_evals: "تقييمات مكتملة",
    minutes_short: "د",
    book_service: "احجز الآن",
    trust_verified: "خبير موثّق",
    trust_top_rated: "الأعلى تقييماً",
    trust_fast: "سريع الرد",
    trust_vip: "VIP موثّق",
    no_achievements: "لم تُضاف إنجازات بعد",
    no_gallery: "لا توجد صور بعد",
    edit_profile: "تحرير الملف",
    save_profile: "حفظ الملف",
    profile_saved: "تم حفظ الملف",
    add_achievement: "إضافة إنجاز",
    add_to_gallery: "إضافة صورة",
    achievement_title: "العنوان (مثال: فائز — كأس المزاين)",
    achievement_year: "السنة",
    upload_photo: "رفع صورة",
    bio: "النبذة",
    expert_count_today: "تقييمات اليوم",
    rank: "المرتبة",
    rating: "التقييم",
    reviews: "آراء العملاء",
    pick_expert: "اختر الخبير",
    hide: "إخفاء",
    show: "إظهار",
    hidden: "مخفي",
    visibility: "الظهور",
    // Free try & tiers
    free_try_title: "تقييم مجاني خلال ٣٠ ثانية",
    free_try_sub: "ارفع صورة حلالك — بدون تسجيل. واحصل على شارة فورية لمستواك.",
    free_try_cta: "جرّب الآن — مجاناً",
    drop_photo_hint: "اسحب صورة هنا، أو اضغط للاختيار",
    analyzing: "جاري تحليل حلالك…",
    your_score: "نتيجتك",
    locked_full_report: "افتح التقرير الكامل + تحليل مفصل بالاشتراك",
    locked_helper: "تفصيل لكل جزء من الجسم، نصائح خبراء، شهادة قابلة للمشاركة، ترتيب رسمي.",
    create_free_account: "أنشئ حساباً مجاناً",
    full_results_after_signup: "النتائج الكاملة تظهر بعد التسجيل",
    tier_elite: "النخبة",
    tier_premium: "ممتاز جداً",
    tier_strong: "قوي",
    tier_good: "جيد",
    tier_developing: "يحتاج تحسين",
    tier_beginner: "مبتدئ",
    elite_msg: "🔥 حلالك من النخبة",
    mazayen_readiness: "نسبة دخولك للمزاين",
    mazayen_ready_high: "تنافسي بقوة — شارك في مسابقة الآن",
    mazayen_ready_mid: "جيد — حسّن نقاط الضعف ولك مكان في المزاين",
    mazayen_ready_low: "الأساس يحتاج عمل قبل المنافسة",
    // Period tabs (animals leaderboard)
    top_today: "أفضل اليوم",
    top_week: "أفضل الأسبوع",
    top_month: "أفضل الشهر",
    top_all: "كل الوقت",
    challenge_today: "تحدّي اليوم",
    challenge_subtitle: "{n} حلال شارك اليوم — تنافس على المركز الأول",
    challenge_no_subs: "لا توجد مشاركات بعد اليوم — كن أول من يشارك!",
    yesterday_winner: "بطل الأمس",
    submit_animal: "شارك بحلالك",
    join_challenge: "انضم للتحدّي",
    top1_badge: "Top 1",
    top10_badge: "Top 10",
    top100_badge: "Top 100",
    regional_reach: "الانتشار الإقليمي",
    regional_subtitle: "موثوق به من ملاك الحلال والحكّام في كل دول الخليج",
    country_users: "ملّاك",
    country_experts: "خبراء",
    country_animals: "حلال",
    // Pricing benefits
    pricing_title: "خططٌ تُصنع منها البطولات",
    pricing_sub: "اختر الخطة التي تجعل حلالك يفوز في كل مزاين.",
    most_popular: "🔥 الأكثر اختياراً",
    first_eval_free: "تجربة أول تقييم مجاني 🎁",
    benefit_30s: "تقييم بالذكاء الاصطناعي خلال ٣٠ ثانية مع شارة المستوى",
    benefit_report: "تقرير يوضّح نقاط القوة والضعف ونسبة دخولك للمزاين",
    benefit_share: "شهادة قابلة للمشاركة على واتساب / إكس / إنستغرام",
    benefit_expert: "مراجعة من خبراء خليجيين معتمدين",
    benefit_unlimited: "تقييمات بلا حدود",
    benefit_priority: "أولوية في طابور الخبراء",
    benefit_videocall: "استشارة بالفيديو مع الخبير",
    benefit_history: "سجل كامل لجميع تقييماتك",
    benefit_compete: "دخول المسابقات والترتيب العام",
    benefit_certificate: "شهادات موثّقة بـ QR",
    // Social proof
    social_evaluations: "+{n} حلال تم تقييمه",
    social_users: "+{n} مستخدم نشط",
    social_experts: "+{n} خبير موثّق",
    // Footer trust
    privacy_policy: "سياسة الخصوصية",
    terms_of_service: "الشروط والأحكام",
    contact_support: "تواصل مع الدعم",
    whatsapp_support: "دعم واتساب",
    official_email: "البريد الرسمي",
    privacy_title: "سياسة الخصوصية",
    terms_title: "الشروط والأحكام",
    last_updated: "آخر تحديث",
    // Smart breed + pricing (Phase 15)
    breed_detected: "كشف السلالة بالذكاء الاصطناعي",
    breed_label: "السلالة المكتشفة",
    confidence_label: "نسبة الثقة",
    your_choice: "اختيارك",
    breed_match: "متطابقة",
    breed_mismatch: "غير متطابق — راجع السلالة",
    classification_label: "التصنيف",
    cls_ordinary: "عادي",
    cls_good: "طيب",
    cls_premium: "ممتاز",
    cls_elite: "نخبة",
    estimated_price: "السعر السوقي المتوقع",
    price_range: "النطاق",
    price_disclaimer: "نطاق استرشادي بناءً على تقييم AI + السلالة، وليس عرضاً ملزماً.",
    score_out_of_10: "النتيجة",
    // Market (Phase 16)
    market: "السوق",
    market_title: "سوق ثقة",
    market_subtitle: "حلال موثّق بتقييمات الذكاء الاصطناعي — معروض من ملاك في جميع دول الخليج",
    sale_price: "السعر المطلوب",
    estimated_value: "تقدير الذكاء الاصطناعي",
    contact_whatsapp: "تواصل عبر واتساب",
    list_for_sale: "اعرضه للبيع",
    unlist: "إلغاء العرض",
    listed_for_sale: "معروض للبيع",
    asking_price_label: "السعر المطلوب (ريال)",
    whatsapp_label: "رقم واتساب (أرقام فقط مع رمز الدولة)",
    whatsapp_placeholder: "966501234567",
    no_market_results: "لا توجد نتائج مطابقة لاختياراتك",
    sort_newest: "الأحدث",
    sort_price_asc: "الأقل سعراً",
    sort_price_desc: "الأعلى سعراً",
    sort_score: "الأعلى تقييماً",
    save_listing: "حفظ العرض",
    listing_saved: "تم تحديث العرض",
    market_disclaimer: "ثقة منصة وصل بين البائع والمشتري؛ التعاملات مباشرة بين الطرفين.",
    // Referral
    referral_invite: "ادعُ صديقاً واحصلا معاً على تقييم مجاني",
    referral_invite_sub: "شارك رمزك أدناه — عند تسجيل صديقك، يحصل كل منكما على تقييم AI مجاني.",
    share_referral: "شارك رمزي",
    // Share result
    share_result: "مشاركة النتيجة",
    share_result_msg: "حصلت على نتيجة",
    share_image: "حفظ صورة المشاركة",

    // Mobile home dashboard
    mhd_welcome: "مرحباً بك في",
    mhd_platform: "منصة مزاين ثقة",
    mhd_subtitle: "تجربة احترافية لمزاين الإبل والخيل",
    mhd_search_placeholder: "ابحث عن ناقة، مالك، مزاين…",
    mhd_total_users: "إجمالي المستخدمين",
    mhd_total_animals: "إجمالي الحلال",
    mhd_active_evals: "تقييمات نشطة",
    mhd_active_aucts: "خبراء نشطون",
    mhd_services_title: "الخدمات الرئيسية",
    mhd_hero_title: "اكتشف نخبة الحلال",
    mhd_hero_sub: "أفضل السلالات وأقوى المنافسات",
    mhd_hero_cta: "استكشف الآن",
    mhd_recent_title: "آخر الأنشطة",
    mhd_act_eval_done: "تم تقييم جديد",
    mhd_act_market_listed: "إعلان جديد في السوق",
    mhd_act_expert_review: "تقييم خبير جديد",
    svc_register: "توثيق الحلال",
    svc_evaluate: "تقييم الحلال",
    svc_tamper: "كشف العبث",
    svc_auctions: "سوق ثقة",
    svc_experts: "الخبراء",
    svc_contests: "المسابقات",
    svc_vet: "العيادة البيطرية",
    svc_subscribe: "اشترك",
    svc_subscribe_badge: "99/شهر",
    svc_grow: "طور حلالك",
    svc_grow_badge: "جديد",
    svc_influencers: "المؤثرين",
    svc_document: "وثّق حلالك",
    svc_specs: "مواصفات الزين",
    svc_track: "الوضع",
    svc_sell: "اعرض حلالك",
    nav_sell: "اعرض حلالك",
    // Track toggle (AR)
    track_mazayen: "المزاين",
    track_races: "السباقات",
    mhd_races_title: "خدمات سباقات الهجن",
    // Racing tiles
    svc_race_register: "تسجيل هجن السباق",
    svc_race_eval: "جاهزية السباق",
    svc_race_sell: "اعرض هجن السباق",
    svc_race_calendar: "دليل السباقات",
    svc_pedigree: "شهادة نسب",
    // Race Calendar (AR)
    races_title: "دليل سباقات الهجن",
    races_sub: "أكبر سباقات الهجن في الخليج — مواعيد، جوائز، وفتح التسجيل.",
    races_no_events: "لا توجد سباقات قادمة — يتم تحديث الدليل.",
    races_view_details: "التفاصيل",
    races_register_cta: "سجّل هجنك",
    races_prize: "قيمة الجوائز",
    races_entry_fee: "رسوم التسجيل",
    races_until: "حتى",
    races_open: "التسجيل مفتوح",
    races_closed: "التسجيل مُغلق",
    races_filter_all: "الكل",
    races_filter_sa: "السعودية",
    races_filter_ae: "الإمارات",
    races_filter_kw: "الكويت",
    races_filter_qa: "قطر",
    // Race Readiness (AR)
    re_title: "تحليل جاهزية السباق",
    re_sub: "ارفع صورة واضحة + (اختياري) فيديو قصير. الذكاء الاصطناعي يحلّل اللياقة، المشية، وقدرة السباق.",
    re_upload: "ارفع الصورة",
    re_video: "ارفع فيديو قصير (اختياري)",
    re_run: "ابدأ التحليل",
    re_running: "جاري تحليل الجاهزية…",
    re_score: "درجة الجاهزية",
    re_breakdown: "التحليل التفصيلي",
    re_fitness: "اللياقة العامة",
    re_build: "البنية والقوام",
    re_legs_back: "القوائم والظهر",
    re_neck_head: "الرقبة والرأس",
    re_recommendations: "توصيات المدرب",
    re_pro_cta: "احصل على التقرير الاحترافي (199 ر.س)",
    re_pro_includes: "يشمل: مقارنة نسب 5 أجيال، خطة تدريب من خبير، شهادة PDF موثقة.",
    // Pedigree (AR)
    ped_title: "شهادات نسب هجن السباق",
    ped_sub: "وثّق حتى 5 أجيال مع التحقق من السلالة + سجل السباقات. ترفع قيمة بيع هجنك أكثر من 100,000 ر.س.",
    ped_apply: "قدّم طلب شهادة",
    ped_price: "299 ر.س لكل شهادة",
    ped_includes: "تشمل:",
    ped_inc1: "شجرة نسب 5 أجيال مع الصور",
    ped_inc2: "سجل سباقات الأب والأم",
    ped_inc3: "شهادة قابلة للطباعة موثّقة بـ QR",
    ped_inc4: "أهلية العرض في سوق ثقة",
    ped_inc5: "تجديد سنوي + دعم نقل الملكية",
    ped_form_camel: "اسم الهجن",
    ped_form_microchip: "الشريحة / الرقم التعريفي",
    ped_form_sire: "اسم الأب وبيانات تواصل المالك",
    ped_form_dam: "اسم الأم وبيانات تواصل المالك",
    ped_form_history: "سجل السباقات (النتائج والتواريخ)",
    ped_submit: "إرسال الطلب — 299 ر.س",
    ped_submitted: "تم إرسال الطلب! سيتم المراجعة والرد خلال 48 ساعة.",
    ped_pdf_soon: "ستصلك الشهادة PDF بالبريد خلال 5 أيام عمل من الموافقة.",
    ped_form_lineage: "السلالات البارزة (اختياري)",
    // Sell-through-Thqah landing (AR)
    sell_eyebrow: "خدمة الوساطة",
    sell_title: "اعرض حلالك عبر ثقة فقط",
    sell_sub_1: "نحن لا نعرض أي حلال بدون تقييم.",
    sell_sub_2: "نستلم بياناتك، نقيمها بدقة، نحدد السعر المناسب، ونعرضها على نخبة المشترين.",
    sell_b1_t: "وصول لكبار التجار",
    sell_b1_d: "شبكة منتقاة من المشترين الموثوقين في الخليج.",
    sell_b2_t: "تسعير احترافي",
    sell_b2_d: "تقييم خبير + ذكاء اصطناعي يحدد السعر العادل — لا بيع بأقل من قيمته.",
    sell_b3_t: "عرض مميز",
    sell_b3_d: "إبراز خاص، صور احترافية، ووثائق كاملة.",
    sell_how_title: "كيف تعمل الخدمة",
    sell_step1_t: "أرسل بيانات حلالك",
    sell_step1_d: "صور وفيديو ومعلومات السلالة والتاريخ — دقائق فقط عبر التطبيق.",
    sell_step2_t: "نُقيّم ونحدد السعر",
    sell_step2_d: "مراجعة خبير + تقييم ذكي. تحصل على السعر المقترح للبيع.",
    sell_step3_t: "نعرض على نخبة المشترين",
    sell_step3_d: "إعلان مميز، عروض شراء مباشرة، وتحويل آمن.",
    sell_plan_badge: "العضوية الذهبية",
    sell_pricing_desc: "الاشتراك يفتح التقييم والتسعير والإبراز. العمولة تُحتسب فقط عند البيع الناجح.",
    sell_commission_line: "عمولة 5% عند البيع فقط",
    sell_inc1: "تقييمات خبير + ذكاء اصطناعي بلا حدود",
    sell_inc2: "عرض مميز أمام مشترين موثقين",
    sell_inc3: "كشف العبث + إعلانات خاصة",
    sell_inc4: "إلغاء الاشتراك في أي وقت",
    sell_cta: "اشترك الآن واعرض حلالك",
    sell_secure_payment: "دفع آمن عبر Tap (مدى • Apple Pay • فيزا)",
    sell_finepoint_t: "ملاحظة مهمة",
    sell_finepoint_d: "يجب اجتياز الحلال للتقييم قبل عرضه للعموم. عمولة الـ 5% تُخصم تلقائياً من حقوق البائع — فقط عند إتمام البيع.",
    sell_browse_link: "تصفح كتالوج الحلال المُقيَّم",
    // Request expert evaluation
    req_cta: "اطلب تقييم خاص من الخبير",
    req_cta_sub: "ارفع الصور والفيديوهات واحصل على رأي الخبير مباشرة.",
    req_cta_login: "سجّل دخول لطلب تقييم",
    req_title: "تقييم خاص من الخبير",
    req_title_small: "طلب جديد",
    req_service: "نوع الخدمة",
    req_photos: "الصور",
    req_videos: "الفيديوهات",
    req_notes: "ملاحظات للخبير",
    req_notes_placeholder: "السلالة، العمر، أي نقطة محددة تريد من الخبير التركيز عليها…",
    req_total: "المجموع",
    req_submit: "إرسال إلى الخبير",
    req_sent: "تم الإرسال ✓ سيردّ عليك الخبير قريباً.",
    req_failed: "فشل الإرسال — حاول مرة أخرى.",
    req_need_media: "يرجى رفع صورة واحدة على الأقل أو فيديو.",
    req_too_large_img: "حجم الصورة أكبر من ١٠ ميجا.",
    req_too_large_vid: "حجم الفيديو أكبر من ٥٠ ميجا.",
    req_upload_failed: "فشل الرفع — حاول مرة أخرى.",
    req_login_first: "يرجى تسجيل الدخول أولاً.",
    req_disclaimer: "الخبير سيراجع الملفات ويردّ عبر التطبيق. يمكنك متابعة الحالة من لوحتك.",
    animal_name_optional: "اسم الحلال (اختياري)",
    breed_optional: "السلالة (اختياري)",
    upload: "رفع",
    sending: "جاري الإرسال…",
    bn_home: "الرئيسية",
    bn_alerts: "الإشعارات",
    bn_add: "إضافة",
    bn_messages: "المحفظة",
    bn_more: "المزيد",
    sign_in_whatsapp: "المتابعة بواتساب",
    sign_in_otp: "المتابعة برمز SMS",
    sign_in_apple: "المتابعة عبر آبل",
    coming_soon: "قريباً",
    // Compare feature
    cmp_title: "قارن حلالك",
    cmp_subtitle: "ارفع صورة حلالك وصورة مرجعية ممتازة. الذكاء الاصطناعي يوضّح الفرق خلال ٥ ثوانٍ.",
    cmp_tagline: "مقارنة جنباً إلى جنب بالذكاء الاصطناعي",
    cmp_yours: "صورتك",
    cmp_yours_short: "حلالك",
    cmp_yours_hint: "صورة جانبية أو أمامية واضحة بإضاءة جيدة.",
    cmp_reference: "صورة مرجعية (حلال ممتاز)",
    cmp_ref_short: "المرجع",
    cmp_reference_hint: "حلال من الدرجة الممتازة تريد القياس عليه.",
    cmp_too_large: "يجب أن تكون الصورة أقل من ٨ ميجا.",
    cmp_need_both: "يرجى رفع الصورتين أولاً.",
    cmp_error: "فشل التحليل، حاول مرة أخرى.",
    cmp_start: "ابدأ المقارنة",
    cmp_analyzing: "جاري التحليل…",
    cmp_step1: "ارفع الصورتين",
    cmp_step2: "تحليل ذكاء اصطناعي",
    cmp_step3: "نتيجة واضحة",
    cmp_advisory: "النتيجة أولية بناءً على الذكاء الاصطناعي — الحكم النهائي لخبير معتمد.",
    cmp_free_quota: "الخطة المجانية: مقارنة واحدة يومياً. اشترك للحصول على غير محدود.",
    cmp_subscribe: "اشترك الآن",
    cmp_verdict: "الخلاصة",
    cmp_breakdown: "تفصيل المعايير",
    cmp_cta_expert: "احصل على تقييم خبير دقيق",
    cmp_cta_pdf: "تحميل PDF",
    cmp_cta_retry: "قارن مرة أخرى",
    svc_compare: "قارن حلالك",
    mhd_cta_compare: "قارن حلالك",
    // Tamper Check
    tc_title: "كشف العبث",
    tc_subtitle: "ارفع الصورة وسنكتشف أي تعديلات أو توليد AI باستخدام بيانات EXIF والذكاء البصري.",
    tc_upload_hint: "صورة واضحة وكاملة للحلال. الحد الأقصى 10 ميجا.",
    tc_start: "تحليل الصورة",
    tc_analyzing: "جاري التحليل…",
    tc_score: "درجة الأصالة",
    tc_flags: "العلامات المكتشفة",
    tc_exif_title: "بيانات EXIF",
    tc_no_flags: "لا توجد علامات عبث. الصورة تبدو أصلية.",
    tc_advisory: "النتيجة استرشادية — ينصح بفحص خبير للمسابقات الرسمية.",
    tc_free_quota: "الباقة المجانية: فحصان يومياً. اشترك للاستخدام غير المحدود.",
    tc_retry: "فحص صورة أخرى",
    tc_bad_file: "ارفع صورة أولاً.",
    tc_too_large: "الصورة يجب أن تكون أقل من 10 ميجا.",
    tc_error: "فشل التحليل. حاول مرة أخرى.",
    // Vet Clinic
    vet_list_title: "العيادة البيطرية",
    vet_list_sub: "أطباء مرخّصون يردّون على استشارتك من داخل التطبيق — صور، أعراض، ووصفة.",
    vet_apply_cta: "انضم كطبيب بيطري",
    vet_empty: "لا يوجد أطباء معتمدون حالياً. ترقّب التحديثات.",
    vet_profile_book: "طلب استشارة",
    vet_profile_services: "الخدمات",
    vet_profile_about: "نبذة",
    vet_request_title: "طلب استشارة بيطرية",
    vet_service: "نوع الاستشارة",
    vet_symptoms: "الأعراض / سبب الاستشارة",
    vet_symptoms_ph: "اشرح المشكلة، مدتها، وأي علاج سابق…",
    vet_urgency: "درجة الاستعجال",
    vet_urgency_low: "منخفضة",
    vet_urgency_normal: "عادية",
    vet_urgency_high: "طارئة",
    vet_submit: "إرسال للطبيب",
    vet_sent: "تم الإرسال — سيردّ الطبيب قريباً.",
    vet_my_cons: "استشاراتي",
    vet_status_pending: "بانتظار ردّ الطبيب",
    vet_status_answered: "تم الرد",
    vet_status_closed: "مغلقة",
    vet_response: "رد الطبيب",
    vet_prescription: "الوصفة",
    vet_rate: "قيّم الاستشارة",
    vet_already_rated: "تم التقييم ✓",
    vet_dashboard: "لوحة الطبيب",
    vet_pending: "طلبات قيد الانتظار",
    vet_answered: "تم الرد عليها",
    vet_respond_cta: "الرد",
    vet_respond_text: "التشخيص والنصيحة",
    vet_respond_rx: "الوصفة (اختياري)",
    vet_send_response: "إرسال الرد",
    vet_apply_title: "سجّل كطبيب بيطري مرخّص",
    vet_apply_sub: "املأ البيانات التالية. ستتم مراجعة طلبك خلال 24 ساعة.",
    vet_clinic_name: "اسم العيادة",
    vet_license_id: "رقم الترخيص",
    vet_specialty: "التخصص",
    vet_years_exp: "سنوات الخبرة",
    vet_fee_sar: "رسوم الاستشارة الأساسية (ريال)",
    vet_bio: "نبذة (إنجليزي)",
    vet_bio_ar: "نبذة (عربي)",
    vet_apply_submit: "إرسال الطلب",
    vet_applied_ok: "تم إرسال الطلب — سنخبرك بعد المراجعة.",
    vet_pending_status: "طلبك قيد المراجعة.",
    vet_rejected_status: "تم رفض الطلب.",
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("thqah_lang") || "ar");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("thqah_lang", lang);
  }, [lang]);

  const t = useCallback((key) => dict[lang][key] ?? dict.en[key] ?? key, [lang]);
  const toggle = useCallback(() => setLang((l) => (l === "ar" ? "en" : "ar")), []);

  // Memoise context value — prevents every consumer re-rendering on parent re-render.
  const value = useMemo(() => ({ lang, t, toggle, setLang }), [lang, t, toggle]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
